<template>
    <!-- Only show the editable slider when the user has the permission to change it. -->
    <label
        v-if="acl('edit_configure_metrics')"
        class="grid-inline-slider"
    >
        <span>
            <input
                type="checkbox"
                :checked="metricEnabled"
                @input="updateValue"
            >
            <span
                class="slider"
                :class="{ left: metricEnabled, right: !metricEnabled }"
            >{{ props.params.value }}</span></span>
    </label>
    <!-- Otherwise, show just the slider without input. -->
    <label v-if="!acl('edit_configure_metrics')">
        <span
            class="slider"
            :class="{ left: metricEnabled, right: !metricEnabled }"
        >{{ props.params.value }}</span>
    </label>
</template>
<script setup lang="ts">
import { METRIC_STATUS } from '@/types';
import type { ICellRendererParams } from '@ag-grid-community/core';
import { useACLs } from '@agyletime/vue-3-common/src/composables/acl';
import { defineProps, ref } from 'vue';

const props = defineProps<{
    params: ICellRendererParams;
}>();

const { acl } = useACLs();
const metricEnabled = ref(Boolean(METRIC_STATUS[props.params.value]));

async function updateValue(event: Event) {
    if (!acl('edit_configure_metrics')) return;

    const target = <HTMLInputElement>event.target;
    const selectedNode = props.params.node;

    if (selectedNode.data && selectedNode.data.metricDefinition) {
        selectedNode.data.metricDefinition.isSelected = target.checked;
    }
}
</script>
<style lang="scss">
.grid-inline-slider {
    position: relative;
    display: inline-block;
    width: 84px;
    height: 24px;
    font-size: 12.8px;
    line-height: 24px;

    input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    input:checked + .slider {
        background-color: var(--color-playvox-green-60);
    }

    input:focus + .slider {
        box-shadow: 0 0 1px var(--color-playvox-green-60);
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(76px);
        -ms-transform: translateX(76px);
        transform: translateX(60px);
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: var(--color-eerie-black-50);
        -webkit-transition: 0.4s;
        transition: 0.4s;
        display: inline-flex;
        align-items: center;
        color: var(--color-text--10);
        border-radius: 34px;
        padding-right: 10px;
        padding-left: 10px;

        &.right {
            justify-content: right;
        }
        &.left {
            justify-content: left;
        }
    }

    .slider:before {
        position: absolute;
        content: '';
        height: 16px;
        width: 16px;
        left: 4px;
        bottom: 4px;
        background-color: var(--color-white);
        -webkit-transition: 0.4s;
        transition: 0.4s;
        border-radius: 50%;
    }
}
</style>
